import React, { useState } from 'react';
import Swal from 'sweetalert2';
import TablaProductos from '../components/Admin/TablaProductos';
import TablaCategorias from '../components/Admin/TablaCategorias';
import TablaMarcas from '../components/Admin/TablaMarcas';
import TablaUsuarios from '../components/Admin/TablaUsuarios';
import TablaServicios from '../components/Admin/TablaServicios';
import BotonOpcionesAdmin from '../components/Admin/BotonOpcionesAdmin';
import { useNavigate } from 'react-router-dom';

function PanelAdministracion() {
  const [tabla, setTabla] = useState('');
  const navigate = useNavigate()

  const handleLogout = async () => {
    // Mostrar alerta de confirmación
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Deseas cerrar sesión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green', // Cambié "Verde" a valor válido
      cancelButtonColor: 'red',   // Cambié "Rojo" a valor válido
      confirmButtonText: 'Sí, cerrar sesión',
      cancelButtonText: 'Cancelar',
    });
  
    if (result.isConfirmed) {
      try {
        // Eliminar el token y rol de sessionStorage (si están almacenados)
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('rol');
  
        Swal.fire(
          '¡Cerraste sesión!',
          'Has cerrado sesión correctamente.',
          'success'
        );
  
        // Redirigir a la página de inicio de sesión
        navigate('/agroh_panel')
      } catch (error) {
        // Manejo de errores en caso de que algo falle
        Swal.fire(
          'Error',
          'Hubo un problema al cerrar sesión. Intenta nuevamente.',
          'error'
        );
      }
    }
  };
  

  return (
    <div className="flex flex-col  min-h-screen bg-gray-100 mt-10 mb-10 border-2 border-GrisOscuro">
      {/* Apartado para cerrar sesión */}
      <div className="w-full p-4 bg-white flex justify-end ">
        <button
          onClick={handleLogout}
          className="text-red-600 hover:text-red-800 font-bold"
        >
          Cerrar sesión
        </button>
      </div>

      {/* Encabezado con botones */}
      <header className="w-full p-4 bg-white border-b shadow">
        <h2 className="text-2xl font-bold mb-4 text-center">Panel de Administración</h2>
        <div className="grid grid-cols-2 gap-2 sm:gap-4 md:grid-cols-4 lg:grid-cols-5">
          <BotonOpcionesAdmin setTabla={setTabla} opcion="usuarios" texto="Usuarios" />
          <BotonOpcionesAdmin setTabla={setTabla} opcion="categorias" texto="Categorías" />
          <BotonOpcionesAdmin setTabla={setTabla} opcion="marcas" texto="Marcas" />
          <BotonOpcionesAdmin setTabla={setTabla} opcion="servicios" texto="Servicios" />
          <BotonOpcionesAdmin setTabla={setTabla} opcion="productos" texto="Productos" />
        </div>
      </header>

      {/* Contenido principal con tablas */}
      <main className="flex-1 w-full p-4">
        <h2 className="text-xl sm:text-xl font-bold mb-4 text-center">
          {`${tabla === '' ? 'Seleccionar una Opción' : `Lista de ${tabla}`}`}
        </h2>
        {tabla === 'productos' && <TablaProductos />}
        {tabla === 'categorias' && <TablaCategorias />}
        {tabla === 'marcas' && <TablaMarcas />}
        {tabla === 'usuarios' && <TablaUsuarios />}
        {tabla === 'servicios' && <TablaServicios />}
      </main>
    </div>
  );
}

export default PanelAdministracion;
